type RowProps = {
  label: string;
  value?: number | string;
};

export const Row = ({ label, value }: RowProps) => (
  <div className="flex justify-between text-s-r">
    <span className="text-base-20">{label}</span>
    <span>{value || '-'}</span>
  </div>
);
